<template>
  <li class="iconNav__item">
    <a
      v-if="href"
      :href="href"
      :target="target"
      class="iconNav__button"
    >
      <font-awesome-icon
        class="iconNav__icon"
        :icon="icon"
      />
      <span class="sr-only">
        {{ label }}
      </span>
    </a>
    <button
      v-else
      class="iconNav__button"
      @click="$emit('click')"
    >
      <font-awesome-icon
        class="iconNav__icon"
        :icon="icon"
      />
      <span class="sr-only">
        {{ label }}
      </span>
    </button>
  </li>
</template>

<script>

export default {
  name: 'IconNavItem',
  props: {
    icon: {
      type: [String, Array],
      required: true,
    },
    label: {
      type: [String, Number],
      required: true,
    },
    href: {
      type: String,
      required: false,
      default () {
        return null
      },
    },
    target: {
      type: String,
      required: false,
      default () {
        return null
      },
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
